module.exports = __webpack_public_path__ + "static/media/re.01fea3b6.svg";